import { Empty } from 'app/features/conversations/Components/Empty';
import MessagesList from 'app/features/conversations/Components/MessagesList';
import { useGetSMSQuery } from 'app/services/sms/sms';
import { useGetUserProfileByIdQuery } from 'app/services/user';
import Spinner from 'Components/Spinner';
import { Controller, useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import ConversationLayout from 'app/features/conversations/Components/ConversationLayout';
import useLoadSMS from 'app/features/conversations/Hooks/useLoadSMS';
import React, { useEffect, useState } from 'react';
import MessageBox from 'Components/Form/MessageBox';
import Tooltip from 'Components/Tooltips';
import { NotFoundIcon, SendMailIcon } from 'assets/icons';
export interface ISMSClientTabProps {}
type SMSContent = {
  showPhoneNumber: Boolean;
  phoneNumber: string | undefined;
};
export const SMSContext = React.createContext<SMSContent>({
  showPhoneNumber: false,
  phoneNumber: '',
});

export default function SMSClientTab(props: ISMSClientTabProps) {
  const { clientId } = useParams();

  const { data, isLoading, isSuccess } = useGetUserProfileByIdQuery(+clientId!);
  const [showPhoneNumber, setShowPhoneNumber] = useState(true);
  const [phoneNumber, setPhoneNumber] = useState(data?.user.phone_number);

  const { data: SMS, isSuccess: isSuccessSMS } = useGetSMSQuery([clientId!]);
  const { handleSubmit, setValue, control } = useForm<{ SMSBody: string }>();

  const {
    hasMorePrevious,
    isLoadingPrevious,
    loadPrevious,
    loadNext,
    isLoadingNext,
    hasMoreNext,
    messages,
    scrollToMessageId,
    append,
    addScrollOffset,
  } = useLoadSMS(Number(clientId)!);

  useEffect(() => {
    isSuccessSMS && setPhoneNumber(data?.user.phone_number);
  }, [isSuccessSMS]);

  return (
    <>
      {isSuccess &&
        SMS &&
        (data?.user.phone_number ? (
          <div className="flex-1 flex flex-col h-full overflow-y-auto">
            <p className=" font-bold text-regular  text-gray-dark">
              SMS Messages
            </p>

            <ConversationLayout
              content={
                <>
                  {messages && SMS.sms_messages.length > 0 ? (
                    <SMSContext.Provider
                      value={{ showPhoneNumber, phoneNumber }}
                    >
                      <MessagesList
                        addScrollOffset={addScrollOffset}
                        scrollToMessageId={scrollToMessageId}
                        loadPrevious={loadPrevious}
                        isLoadingPrevious={isLoadingPrevious}
                        hasMorePrevious={hasMorePrevious}
                        loadNext={loadNext}
                        isLoadingNext={isLoadingNext}
                        hasMoreNext={hasMoreNext}
                        messages={messages}
                      />
                    </SMSContext.Provider>
                  ) : (
                    <Empty
                      title="Start messaging your team"
                      body={<>Send SMS to communicate with your team.</>}
                    />
                  )}
                </>
              }
              footer={
                <form
                  onSubmit={handleSubmit(({ SMSBody }: { SMSBody: string }) => {
                    SMSBody && clientId && append(SMSBody, Number(clientId));
                    setValue('SMSBody', '');
                  })}
                >
                  <Controller
                    name={'SMSBody'}
                    control={control}
                    render={({ field: { onChange, value, ref } }) => (
                      <div className="flex flex-col border p-5 text-regular border-white rounded shadow-all">
                        <MessageBox
                          value={value}
                          onChange={onChange}
                          ref={ref}
                          limit={1600}
                          button={
                            <Tooltip message="Send SMS">
                              <button
                                type="submit"
                                className="focus:outline-none flex-1 rounded-2xl bg-gray-light-10"
                              >
                                <SendMailIcon className="w-4 h-4 text-gray-light" />
                              </button>
                            </Tooltip>
                          }
                        />
                      </div>
                    )}
                  />
                </form>
              }
            />
          </div>
        ) : (
          <div className="flex flex-col items-center mt-16 text-gray-700 ">
            <NotFoundIcon />
            <p className=" py-5 font-extrabold  text-medium text-gray-700 ">
              No SMS Messages
            </p>
            <div className="text-gray-700">
              This client does not have a registered phone number. Therefore,
              there are no SMS messages available
            </div>
          </div>
        ))}
      {isLoading && <Spinner />}
    </>
  );
}
